import { createContext } from 'react';
const defaultValues = {
  environment: undefined,
  tenant: undefined
};
export const environmentContext = /*#__PURE__*/createContext(defaultValues);
//# sourceMappingURL=environmentContext.js.map